module.exports = __webpack_public_path__ + "static/media/saftey-img.af7d4203.png";